
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/tutorial/[postId]",
      function () {
        return require("private-next-pages/tutorial/[postId]/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/tutorial/[postId]"])
      });
    }
  